import { Button } from "react-bootstrap";
import {
  CanAccess,
  AuthorizationList,
} from "../../../components/template/authorization/Authorization";

export const CAPITAL_OUTLET_TYPE = "capital";
export const CASH_OUTLET_TYPE = "cash";

export const initCapitalFilterInput = {
  outlets: [],
  page: 1,
  pageSize: 10,
  sortingField: null,
  sortingOrder: null,
};

export const initCashFilterInput = {
  outlets: [],
  page: 1,
  pageSize: 10,
  sortingField: null,
  sortingOrder: null,
};

export const renderCapitalOutletColumns = (handleEditButtonClick) => {
  return [
    {
      dataIndex: "outletName",
      key: "outletName",
      backend_key: "outlet_name",
      title: "Nama Cabang",
      sorter: true,
      width: "25%",
    },
    {
      dataIndex: "averageSpending",
      key: "averageSpending",
      title: "Rata-rata Pengeluaran Perhari Selama 6 Bulan Terakhir",
      width: "25%",
    },
    {
      dataIndex: "maxAmount",
      key: "maxAmount",
      title: "Jumlah Maksimal",
    },
    {
      dataIndex: "minAmount",
      key: "minAmount",
      title: "Jumlah Minimal",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "grid" }}>
          <CanAccess
            role={AuthorizationList.update_outlet_cash}
            yes={
              <Button
                variant="primary"
                className="btn-action btn-detail"
                onClick={() => handleEditButtonClick(record)}
              >
                Ubah
              </Button>
            }
          />
        </div>
      ),
    },
  ];
};

export const renderCashOutletColumns = (handleEditButtonClick) => {
  return [
    {
      dataIndex: "outletName",
      key: "outletName",
      backend_key: "outlet_name",
      title: "Nama Cabang",
      sorter: true,
      width: "25%",
    },
    {
      dataIndex: "maxAmount",
      key: "maxAmount",
      title: "Jumlah Maksimal",
    },
    {
      dataIndex: "minAmount",
      key: "minAmount",
      title: "Jumlah Minimal",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "grid" }}>
          <CanAccess
            role={AuthorizationList.update_outlet_cash}
            yes={
              <Button
                variant="primary"
                className="btn-action btn-detail"
                onClick={() => handleEditButtonClick(record)}
              >
                Ubah
              </Button>
            }
          />
        </div>
      ),
    },
  ];
};
